export const nfseWebhookTaxAuthorityErrorMappings1 = {
    NFSE_WEBHOOK_E0014_DUPLICATE_DPS: {
        code: 'NFSE_WEBHOOK_E0014_DUPLICATE_DPS',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Já existe uma NFS-e emitida com este conjunto de dados (série, número, município e CNPJ). Esta nota já foi enviada anteriormente como DPS. Verifique a numeração nas configurações.',
            },
            {
                language: 'pt-BR',
                message: 'Já existe uma NFS-e emitida com este conjunto de dados (série, número, município e CNPJ). Esta nota já foi enviada anteriormente como DPS. Verifique a numeração nas configurações.',
            },
            {
                language: 'en-US',
                message: 'An NFS-e already exists with this combination of data (series, number, municipality and CNPJ). This invoice was previously submitted as a DPS. Please check the numbering in settings.',
            },
            {
                language: 'es-ES',
                message: 'Ya existe una NFS-e emitida con este conjunto de datos (serie, número, municipio y CNPJ). Esta factura fue enviada anteriormente como DPS. Verifique la numeración en la configuración.',
            },
        ],
        technicalMessage: 'Conjunto de Série, Número, Código do Município Emissor e CNPJ/CPF informado nesta DPS já existe',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_E0039_CITY_NOT_CONFIGURED_NATIONAL: {
        code: 'NFSE_WEBHOOK_E0039_CITY_NOT_CONFIGURED_NATIONAL',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O município do prestador não está parametrizado para utilizar os emissores públicos nacionais. Verifique a parametrização do município no Sistema Nacional NFS-e ou entre em contato com o suporte.',
            },
            {
                language: 'pt-BR',
                message: 'O município do prestador não está parametrizado para utilizar os emissores públicos nacionais. Verifique a parametrização do município no Sistema Nacional NFS-e ou entre em contato com o suporte.',
            },
            {
                language: 'en-US',
                message: 'The service provider municipality is not configured to use the national public issuers. Check the municipality configuration in the National NFS-e System or contact support.',
            },
            {
                language: 'es-ES',
                message: 'El municipio del prestador no está parametrizado para utilizar los emisores públicos nacionales. Verifique la parametrización del municipio en el Sistema Nacional NFS-e o contacte al soporte.',
            },
        ],
        technicalMessage: 'deve estar parametrizado para utilizar os emissores públicos nacionais',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_E0116_IM_REQUIRED: {
        code: 'NFSE_WEBHOOK_E0116_IM_REQUIRED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'A Inscrição Municipal (IM) é obrigatória para o prestador. Verifique os dados nas configurações.',
            },
            {
                language: 'pt-BR',
                message: 'A Inscrição Municipal (IM) é obrigatória para o prestador. Verifique os dados nas configurações.',
            },
            {
                language: 'en-US',
                message: 'Municipal Registration (IM) is required for the service provider. Please check the settings.',
            },
            {
                language: 'es-ES',
                message: 'La Inscripción Municipal (IM) es obligatoria para el prestador. Verifique los datos en la configuración.',
            },
        ],
        technicalMessage: 'A IM deve ser informada para o emitente prestador do serviço na DPS',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_E0120_IM_SHOULD_NOT_BE_PROVIDED: {
        code: 'NFSE_WEBHOOK_E0120_IM_SHOULD_NOT_BE_PROVIDED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'A Inscrição Municipal (IM) não deve ser informada para este prestador, pois não existem informações complementares registradas no CNC NFS-e do município. Remova a IM das configurações.',
            },
            {
                language: 'pt-BR',
                message: 'A Inscrição Municipal (IM) não deve ser informada para este prestador, pois não existem informações complementares registradas no CNC NFS-e do município. Remova a IM das configurações.',
            },
            {
                language: 'en-US',
                message: 'The Municipal Registration (IM) must not be provided for this service provider, as there are no complementary records registered in the CNC NFS-e for this municipality. Remove the IM from the settings.',
            },
            {
                language: 'es-ES',
                message: 'La Inscripción Municipal (IM) no debe informarse para este prestador, ya que no existen informaciones complementarias registradas en el CNC NFS-e del municipio. Elimine la IM de la configuración.',
            },
        ],
        technicalMessage: 'IM do prestador não deve ser informado, pois não existem informações complementares registradas no CNC NFS-e',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_E0160_SN_STATUS_MISMATCH: {
        code: 'NFSE_WEBHOOK_E0160_SN_STATUS_MISMATCH',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'A situação perante o Simples Nacional informada na NFS-e não está de acordo com o cadastro Simples Nacional para o mês de competência. Verifique o enquadramento tributário da empresa nas configurações.',
            },
            {
                language: 'pt-BR',
                message: 'A situação perante o Simples Nacional informada na NFS-e não está de acordo com o cadastro Simples Nacional para o mês de competência. Verifique o enquadramento tributário da empresa nas configurações.',
            },
            {
                language: 'en-US',
                message: 'The Simples Nacional status declared in the NFS-e does not match the Simples Nacional registry for the competence month. Please check the company tax classification in the settings.',
            },
            {
                language: 'es-ES',
                message: 'La situación ante el Simples Nacional declarada en la NFS-e no coincide con el registro del Simples Nacional para el mes de competencia. Verifique la clasificación tributaria de la empresa en la configuración.',
            },
        ],
        technicalMessage: 'situação perante o Simples Nacional, do prestador, informada na DPS não está de acordo',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_E0166_SN_TAX_REGIME_REQUIRED: {
        code: 'NFSE_WEBHOOK_E0166_SN_TAX_REGIME_REQUIRED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O preenchimento do regime de apuração dos tributos do Simples Nacional é obrigatório para optantes ME/EPP. Verifique as configurações de nota fiscal.',
            },
            {
                language: 'pt-BR',
                message: 'O preenchimento do regime de apuração dos tributos do Simples Nacional é obrigatório para optantes ME/EPP. Verifique as configurações de nota fiscal.',
            },
            {
                language: 'en-US',
                message: 'The Simples Nacional tax assessment regime field is required for ME/EPP enrollees. Please check the invoice settings.',
            },
            {
                language: 'es-ES',
                message: 'El campo de régimen de liquidación de tributos del Simples Nacional es obligatorio para optantes ME/EPP. Verifique la configuración de facturas.',
            },
        ],
        technicalMessage: 'obrigatorio o preenchimento do campo de regime de apuração dos tributos do SN',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_E0310_NATIONAL_TAX_CODE_NOT_FOUND: {
        code: 'NFSE_WEBHOOK_E0310_NATIONAL_TAX_CODE_NOT_FOUND',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O código de tributação nacional informado não existe na lista de serviços do Sistema Nacional NFS-e. Verifique o código de tributação nas configurações de nota fiscal.',
            },
            {
                language: 'pt-BR',
                message: 'O código de tributação nacional informado não existe na lista de serviços do Sistema Nacional NFS-e. Verifique o código de tributação nas configurações de nota fiscal.',
            },
            {
                language: 'en-US',
                message: 'The provided national taxation code does not exist in the National NFS-e System service list. Please check the taxation code in the invoice settings.',
            },
            {
                language: 'es-ES',
                message: 'El código de tributación nacional informado no existe en la lista de servicios del Sistema Nacional NFS-e. Verifique el código de tributación en la configuración de facturas.',
            },
        ],
        technicalMessage: 'O código de tributação nacional informado não existe conforme a lista de serviços nacional',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_E0312_NATIONAL_TAX_CODE_NOT_MANAGED: {
        code: 'NFSE_WEBHOOK_E0312_NATIONAL_TAX_CODE_NOT_MANAGED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O código de tributação nacional não está administrado pelo município de incidência do ISSQN na data de competência da NFS-e. Verifique o código de tributação nas configurações.',
            },
            {
                language: 'pt-BR',
                message: 'O código de tributação nacional não está administrado pelo município de incidência do ISSQN na data de competência da NFS-e. Verifique o código de tributação nas configurações.',
            },
            {
                language: 'en-US',
                message: 'The national taxation code is not managed by the ISSQN incidence municipality on the NFS-e competence date. Please check the taxation code in the settings.',
            },
            {
                language: 'es-ES',
                message: 'El código de tributación nacional no está administrado por el municipio de incidencia del ISSQN en la fecha de competencia de la NFS-e. Verifique el código de tributación en la configuración.',
            },
        ],
        technicalMessage: 'O código de tributação nacional informado não está administrado pelo município',
        severity: 'error',
        critical: false,
    },
};
